import React, { useRef } from 'react'
import { BookOpen, Code, Info, MessageCircle, Book, Users } from 'react-feather'
import styled, { css } from 'styled-components'
import { ReactComponent as MenuIcon } from '../../assets/images/menu.svg'
// import { useActiveWeb3React } from '../../hooks'

import { useOnClickOutside } from '../../hooks/useOnClickOutside'
import { ApplicationModal } from '../../state/application/actions'
import { useModalOpen, useToggleModal } from '../../state/application/hooks'

import { ExternalLink } from '../../theme'
// import { ButtonPrimary } from '../Button'
import { isMobile } from 'react-device-detect'
import { ReactComponent as Discord } from '../../assets/svg/discord_icon.svg'
import { ReactComponent as Coingecko } from '../../assets/svg/coingecko.svg'
import { ReactComponent as Coinmarketcap } from '../../assets/svg/coinmarketcap.svg'

const StyledMenuIcon = styled(MenuIcon)`
  path {
    stroke: white;
  }
`

const DiscordIcon = styled(Discord)`
  width: 14px;
  height: 14px;
`
const CoingeckoIcon = styled(Coingecko)`
  width: 14px;
  height: 14px;
`
const CoinmarketcapIcon = styled(Coinmarketcap)`
  width: 14px;
  height: 14px;
`

const StyledMenuButton = styled.button`
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: #404450;

  padding: 0.15rem 0.5rem;
  border-radius: 10px;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: #404450;
    opacity:0.9;
  }

  svg {
    margin-top: 2px;
  }
`

const StyledMenu = styled.div`
  margin-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border: none;
  text-align: left;
`

const MenuFlyout = styled.span`
  min-width: 9.125rem;
  /* background-color: ${({ theme }) => theme.bg3}; */
  background: #0E161A;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.25);
  border-radius: 13px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  position: absolute;
  top: 4rem;
  right: 0rem;
  z-index: 100;

  ${({ theme }) => theme.mediaWidth.upToSupLarge`
    top: -21.25rem;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    ${
      isMobile && css`
        top: 0;
        transform: translateY(-110%);
      `
    }
  `};
`

const MenuItem = styled(ExternalLink)`
  flex: 1;
  padding: 0.5rem 0.5rem;
  color: ${({ theme }) => theme.text2};
  font-size: 12px;
  display: flex;
  align-items: center;
  :hover {
    color: ${({ theme }) => theme.text1};
    cursor: pointer;
    text-decoration: none;
  }
  &:hover .menu_svg_icon path{
    fill: ${({ theme }) => theme.text1};
  }
  > svg {
    margin-right: 8px;
  }
`

export default function Menu() {
  // const { account } = useActiveWeb3React()

  const node = useRef<HTMLDivElement>()
  const open = useModalOpen(ApplicationModal.MENU)
  const toggle = useToggleModal(ApplicationModal.MENU)
  useOnClickOutside(node, open ? toggle : undefined)
  // const openClaimModal = useToggleModal(ApplicationModal.ADDRESS_CLAIM)

  return (
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30451
    <StyledMenu ref={node as any}>
      <StyledMenuButton onClick={toggle}>
        <StyledMenuIcon />
      </StyledMenuButton>

      {open && (
        <MenuFlyout>
          {<MenuItem id="link" href="https://twitter.com/HuckleberryDex">
            <Info size={14} />
            Twitter
          </MenuItem>}
          {<MenuItem id="link" href="https://t.me/HuckleberryDrifters">
            <MessageCircle size={14} />
            Telegram
          </MenuItem>}
          {<MenuItem id="link" href="https://discord.gg/rkAPmW9ZUk">
            <DiscordIcon className='menu_svg_icon' />
            Discord
          </MenuItem>}
          <MenuItem id="link" href="https://medium.com/@HuckleberryDEX">
            <BookOpen size={14} />
            Medium
          </MenuItem>
          <MenuItem id="link" href="https://huckleberry.gitbook.io/introduction">
            <BookOpen size={14} />
            Docs
          </MenuItem>
          <MenuItem id="link" href="https://vote.huckleberry.finance">
            <Users size={14} />
            Vote
          </MenuItem>
          {/* <MenuItem id="link" href="https://t.me/HuckleberryCommunity">
            <MessageCircle size={14} />
            Telegram
          </MenuItem> */}
          {/* <MenuItem id="link" href="https://github.com/HuckleberryDex/huckleberry-interface/discussions">
            <MessageCircle size={14} />
            Discussions
          </MenuItem> */}
          <MenuItem id="link" href="https://github.com/huckleberrydex">
            <Code size={14} />
            Github
          </MenuItem>
          <MenuItem id="link" href="https://github.com/HuckleberryDex/audit-reports">
            <Book size={14} />
            Audit
          </MenuItem>
          <MenuItem id="link" href="https://www.coingecko.com/en/coins/huckleberry">
            <CoingeckoIcon className='menu_svg_icon' />
            CoinGecko
          </MenuItem>
          <MenuItem id="link" href="https://coinmarketcap.com/currencies/huckleberry/">
            <CoinmarketcapIcon className='menu_svg_icon' />
            CoinMarketCap
          </MenuItem>
          
          {
          /*
          <MenuItem id="link" href="https://uniswap.info/">
            <PieChart size={14} />
            Analytics
          </MenuItem> */}
          {/* {account && (
            <ButtonPrimary onClick={openClaimModal} padding="8px 16px" width="100%" borderRadius="12px" mt="0.5rem">
              Claim FINN
            </ButtonPrimary>
          )} */}
        </MenuFlyout>
      )}
    </StyledMenu>
  )
}
